import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, Typography, makeStyles, Grid } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { BuildingsMap } from "../../../demo/components/BuildingsMap";
import { styles } from "../../../../theme/styles";
import { SummaryBox } from "../../components/SummaryBox";
import solarImg from "../../../../assets/images/icons/solar.svg";
import settingsImg from "../../../../assets/images/icons/settings.svg";
import lightningImg from "../../../../assets/images/icons/lightning.svg";
import { getData } from "../../../../services";

const useStyles = makeStyles(() => ({
  headerTitle: {
    fontSize: 36,
    "& > span": {
      fontSize: 48,
      fontWeight: "bold",
      color: COLORS.purple,
    },
  },
  summarizeContainer: {
    marginTop: 20,
    padding: "20px 0",
    border: `solid 1px ${COLORS.darks[0][10]}`,
    borderRadius: 8,
    boxShadow: styles.boxShadows.darks[6],
  },
}));

const defaultSolarPotential = {
  total_roof_eic: null,
  total_roof_aep: null,
  total_parking_lots_eic: null,
  total_parking_lots_aep: null,
};

export const MapTab = ({ buildings }) => {
  const classes = useStyles();
  const { clusters } = useSelector((state) => state.auth);
  const [solarPotential, setSolarPotential] = useState(defaultSolarPotential);

  useEffect(() => {
    getData(
      `/onboarding/base/solar-potential-analytics/?clusters=${clusters[0].id}`,
      setSolarPotential
    );

    return () => {
      setSolarPotential({});
    };
  }, []);

  const verifiedAddressesBuildingCount = () => {
    const unverifiedBuidlings = buildings.filter((building) => !building.is_valid_address);

    return buildings.length - unverifiedBuidlings.length;
  };

  return (
    <>
      <Box mt={3.5}>
        <Typography className={classes.headerTitle}>
          <span>{verifiedAddressesBuildingCount()}</span> buildings
        </Typography>
      </Box>

      <Box
        px={3}
        py={1}
        border={`1px solid ${COLORS.darks[0][10]}`}
        borderRadius={8}
        boxShadow={styles.boxShadows.darks[6]}
        display="flex"
        flexDirection="column"
        gridRowGap={10}
      >
        <Typography variant="h4">
          The <span style={{ color: COLORS.purple }}>PRaaS System</span> has calculated the
          Estimated Power Revenues based on your data
        </Typography>
        <BuildingsMap buildings={buildings} height={300} />

        {clusters[0].preliminary_stage.solar_forecast !== "EXCLUDE" ? (
          <Box my={2}>
            <Typography variant="h2">Solar potential</Typography>
            <Grid container className={classes.summarizeContainer}>
              <Grid item xs={6} style={{ borderRight: `solid 1px ${COLORS.darks[0][10]}` }}>
                <SummaryBox
                  iconSrc={solarImg}
                  preIconSrc={settingsImg}
                  text="Est. installed capacity"
                  roof={solarPotential.total_roof_eic}
                  parkingLots={solarPotential.total_parking_lots_eic}
                  unitMeasurement="kWp"
                  preIconStyle={{
                    right: "-14px",
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <SummaryBox
                  iconSrc={solarImg}
                  preIconSrc={lightningImg}
                  text="Annual electricity production"
                  roof={solarPotential.total_roof_aep}
                  parkingLots={solarPotential.total_parking_lots_aep}
                  preIconStyle={{
                    right: "-6px",
                  }}
                  iconBlockStyle={{
                    border: `1.5px dashed ${COLORS.mikadoYellow}`,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        ) : null}
      </Box>
    </>
  );
};
